import Vue from "vue";
import serverTranslationsMixin from "@/mixins/serverTranslations";
export default {
  methods: {
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    extractBirthDate(cardType, cardID) {
      if (cardType === 1 && cardID.length === 14) {
        let { day, month, year } = "";
        day = cardID.slice(5, 7);
        month = cardID.slice(3, 5);
        if (cardID.slice(0, 1) === "2") {
          year = "19" + cardID.slice(1, 3);
        } else {
          year = "20" + cardID.slice(1, 3);
        }
        return year + "-" + month + "-" + day;
      } else {
        return null;
      }
    },
    extractGender(cardType, cardID) {
      if (cardType === 1 && cardID.length === 14) {
        const genderType = cardID.slice(12, 13);
        if (genderType % 2 === 0) {
          return 14;
        } else {
          return 13;
        }
      } else {
        return 13;
      }
    },
    extractGenderAndBirthDate(cardType, cardID) {
      return {
        birthDate: this.extractBirthDate(cardType, cardID),
        gender: this.extractGender(cardType, cardID)
      };
    },
    scrollToErrorControl(form) {
      if (!form.validate()) {
        const invalidControl = this.$el.querySelector(".error--text");
        return invalidControl.scrollIntoView(false);
      }
    },
    showToasted(type, msg) {
      if(type == "success") {
         Vue.toasted.show(serverTranslationsMixin.methods.serverTranslate(msg), {
          type: "success",
          icon: "check_circle_outline",
          duration: 5000,
          theme: "bubble",
          position: "bottom-left"
         });
      } else if (type == "error") {
         Vue.toasted.show(serverTranslationsMixin.methods.serverTranslate(msg), {
           type: "error",
           icon: "error_outline",
           position: "bottom-left",
           theme: "bubble",
           duration: 5000
         });
      }
    },
  }
};
